export default {
  className: 'InformationPosts',
  fields: [
    'type',
    'author',
    'content',
    'likeUser',
    'userFans',
    'commentUser',
    'pictureCombination'
  ],
  search: [
    'type',
    'author'
  ],
  action: {
    create: false,
    edit: false,
    view: {
      type: 'row',
      text: '查看',
      viewTitle: '查看发帖详情',
      component: 'viewPage'
    }
  },
  hooks: {
  }
}
